<div *ngIf="showModal && !showDownloadModal"
  class="product-preview-modal fixed inset-0 z-[9999999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-2 sm:p-4"
  style="position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; z-index: 9999999 !important;"
  (click)="closeModal()">
  <div role="presentation" (click)="$event.stopPropagation()"
    class="modal-content relative w-full max-w-4xl h-[80vh] max-h-[80vh] bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col lg:flex-row animate-modal z-[9999999]">
    <!-- Close Button -->
    <button (click)="closeModal()"
      class="absolute top-3 right-3 z-10 w-8 h-8 bg-white/90 hover:bg-white text-gray-600 hover:text-gray-800 rounded-full flex items-center justify-center transition-all duration-200 shadow-md hover:shadow-lg"
      [attr.aria-label]="'Zamknij okno' | translate">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>

    <!-- Left Section - Product Gallery -->
    <div class="flex-1 lg:w-1/2 lg:max-w-none bg-white flex flex-col min-h-0">
      <!-- Product Gallery -->
      <div class="flex-1 p-2 md:p-3">
        <!-- Main Image/Video -->
        <div class="mb-1">
          <div class="product-main-media aspect-[4/3] w-full bg-white rounded-lg overflow-hidden border border-gray-200 relative group">
            <!-- YouTube Video Display -->
            <ng-container
              *ngIf="isYouTubeUrl(selectedGalleryImages?.[currentImageIndex]?.url); else videoOrImageTemplate">
              <iframe class="w-full h-full"
                [src]="getYouTubeEmbedUrl(selectedGalleryImages[currentImageIndex]?.url) + '?autoplay=0&rel=0' | safe: 'resourceUrl'"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
              </iframe>
            </ng-container>

            <!-- Video Display -->
            <ng-template #videoOrImageTemplate>
              <ng-container *ngIf="isVideoFile(selectedGalleryImages?.[currentImageIndex]?.url); else imageTemplate">
                <video #mainVideo
                  class="w-full h-full object-contain cursor-pointer"
                  [src]="selectedGalleryImages[currentImageIndex]?.url"
                  [title]="selectedGalleryImages[currentImageIndex]?.alt || ('Główny film produktu' | translate)" muted
                  preload="metadata" (click)="toggleVideoPlayback(mainVideo)">
                  {{ 'Twoja przeglądarka nie obsługuje odtwarzacza wideo.' | translate }}
                </video>

                <!-- Custom Play/Pause Overlay -->
                <div *ngIf="mainVideo?.paused !== false"
                  class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 cursor-pointer z-10"
                  (click)="toggleVideoPlayback(mainVideo)">
                  <div class="bg-white bg-opacity-90 rounded-full p-4 hover:bg-opacity-100 transition-all duration-200">
                    <svg class="w-10 h-10 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>

                </div>

                <!-- Video Controls Overlay (when playing) -->
                <div *ngIf="mainVideo?.paused === false"
                  class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 z-10 opacity-0 hover:opacity-100 transition-opacity duration-200">
                  <div class="flex gap-2">
                    <!-- Pause Button -->
                    <button (click)="toggleVideoPlayback(mainVideo); $event.stopPropagation()"
                      class="bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-3 transition-all duration-200">
                      <svg class="w-6 h-6 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
                      </svg>
                    </button>

                    <!-- Stop Button -->
                    <button (click)="stopVideo(mainVideo); $event.stopPropagation()"
                      class="bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-3 transition-all duration-200">
                      <svg class="w-6 h-6 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M6 6h12v12H6z" />
                      </svg>
                    </button>

                    <!-- Mute/Unmute Button -->
                    <button (click)="toggleVideoMute(mainVideo); $event.stopPropagation()"
                      class="bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-3 transition-all duration-200">
                      <svg *ngIf="mainVideo?.muted" class="w-6 h-6 text-gray-800" fill="currentColor"
                        viewBox="0 0 24 24">
                        <path
                          d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" />
                      </svg>
                      <svg *ngIf="!mainVideo?.muted" class="w-6 h-6 text-gray-800" fill="currentColor"
                        viewBox="0 0 24 24">
                        <path
                          d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                      </svg>
                    </button>
                  </div>
                </div>

              </ng-container>

              <!-- Image Display -->
              <ng-template #imageTemplate>
                <!-- Try to show as video first if URL contains video indicators -->
                <ng-container
                  *ngIf="selectedGalleryImages?.[currentImageIndex]?.url && (selectedGalleryImages[currentImageIndex]?.url.includes('video') || selectedGalleryImages[currentImageIndex]?.url.includes('.mp4') || selectedGalleryImages[currentImageIndex]?.url.includes('.mov') || selectedGalleryImages[currentImageIndex]?.url.includes('.webm')); else fallbackImage">
                  <video #fallbackVideo
                    class="w-full h-full object-contain cursor-pointer"
                    [src]="selectedGalleryImages[currentImageIndex]?.url"
                    [title]="selectedGalleryImages[currentImageIndex]?.alt || ('Film produktu' | translate)" muted preload="metadata"
                    (click)="toggleVideoPlayback(fallbackVideo)">
                    {{ 'Twoja przeglądarka nie obsługuje odtwarzacza wideo.' | translate }}
                  </video>

                  <!-- Play overlay for fallback video -->
                  <div *ngIf="fallbackVideo?.paused !== false"
                    class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 cursor-pointer z-10"
                    (click)="toggleVideoPlayback(fallbackVideo)">
                    <div
                      class="bg-white bg-opacity-90 rounded-full p-4 hover:bg-opacity-100 transition-all duration-200">
                      <svg class="w-10 h-10 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                </ng-container>

                <!-- Fallback to image -->
                <ng-template #fallbackImage>
                  <img
                    [src]="(selectedGalleryImages && selectedGalleryImages[currentImageIndex]?.url) || getFirstAvailableImage() || '/images/placeholder-product.svg'"
                    [alt]="product?.label"
                    class="w-full h-full object-contain"
                    loading="lazy" />
                </ng-template>
              </ng-template>
            </ng-template>
          </div>
        </div>

        <!-- Thumbnail Images/Videos -->
        <div class="flex gap-2 overflow-x-auto pb-2 scrollbar-hide"
          *ngIf="selectedGalleryImages && selectedGalleryImages.length > 1">
          <button *ngFor="let image of selectedGalleryImages; let i = index" (click)="selectImage(i)"
            class="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-md overflow-hidden border-2 transition-all duration-200 relative"
            [class.border-orange-500]="i === currentImageIndex" [class.border-gray-200]="i !== currentImageIndex"
            [class.hover:border-orange-300]="i !== currentImageIndex">

            <!-- YouTube Video Thumbnail -->
            <ng-container *ngIf="isYouTubeUrl(image?.url); else videoOrImageThumbnail">
              <img [src]="'https://img.youtube.com/vi/' + getYouTubeVideoId(image?.url) + '/maxresdefault.jpg'"
                [alt]="image?.alt || (('Miniatura filmu YouTube ' + (i + 1)) | translate)"
                class="w-full h-full object-contain"
                loading="lazy" (error)="onYouTubeThumbnailError($event, image?.url, i)" #youtubeThumbnail>
              <!-- YouTube Play Icon Overlay -->
              <div class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
                <div class="bg-red-600 rounded-full p-1.5">
                  <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </div>
            </ng-container>

            <!-- Video Thumbnail -->
            <ng-template #videoOrImageThumbnail>
              <ng-container *ngIf="isVideoFile(image?.url); else thumbnailImageTemplate">
                <video class="w-full h-full object-contain bg-white" [src]="image?.url"
                  [title]="image?.alt || (('Miniatura filmu produktu ' + (i + 1)) | translate)" muted preload="metadata">
                </video>
                <!-- Video Play Icon Overlay -->
                <div class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
                  <div class="bg-white bg-opacity-90 rounded-full p-1">
                    <svg class="w-4 h-4 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              </ng-container>

              <!-- Image Thumbnail -->
              <ng-template #thumbnailImageTemplate>
                <img [src]="image.url || getFirstAvailableImage() || '/images/placeholder-product.svg'"
                  [alt]="('Miniatura ' + (i + 1)) | translate" class="w-full h-full object-contain bg-white" loading="lazy" />
              </ng-template>
            </ng-template>
          </button>
        </div>
      </div>

      <!-- Action Icons -->
      <div
        class="flex flex-col sm:flex-row justify-center items-center gap-2 mb-2 p-2 md:p-3 border-t lg:border-t-0 border-gray-100">
        <div class="flex items-center gap-2">
          <!-- Watchlist Icon -->
          <button (click)="toggleWatchlist($event)" [disabled]="isWatchlistPending()"
            [attr.aria-busy]="isWatchlistPending()"
            class="flex items-center justify-center w-10 h-10 transition-all duration-200 hover:shadow-md rounded-full disabled:cursor-wait disabled:opacity-60"
            [class.bg-red-50]="isInWatchlist" [class.text-red-600]="isInWatchlist" [class.bg-gray-100]="!isInWatchlist"
            [class.text-gray-600]="!isInWatchlist" [class.hover:bg-red-50]="!isInWatchlist"
            [class.hover:text-red-600]="!isInWatchlist"
            [attr.aria-label]="(isInWatchlist ? 'Usuń z listy obserwowanych' : 'Dodaj do listy obserwowanych') | translate"
            [title]="(isInWatchlist ? 'Usuń z listy obserwowanych' : 'Dodaj do listy obserwowanych') | translate">
            <svg class="w-5 h-5" viewBox="0 0 24 24" [attr.fill]="isInWatchlist ? 'currentColor' : 'none'"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z">
              </path>
            </svg>
          </button>

          <!-- Compare Icon -->
          <button type="button" (click)="toggleComparison()"
            class="flex items-center justify-center w-10 h-10 rounded-full transition-all duration-200 hover:shadow-md"
            [class.bg-orange-50]="isInComparison()" [class.text-orange-600]="isInComparison()"
            [class.bg-gray-100]="!isInComparison()" [class.text-gray-600]="!isInComparison()"
            [class.hover:bg-orange-50]="!isInComparison()" [class.hover:text-orange-600]="!isInComparison()"
            [attr.aria-pressed]="isInComparison()"
            [attr.aria-label]="(isInComparison() ? 'Usuń z porównania' : 'Dodaj do porównania') | translate"
            [title]="(isInComparison() ? 'Usuń z porównania' : 'Dodaj do porównania') | translate">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 3v3m0 0 7 3m-7-3L5 9m7-3v14m-6 0h12M5 9l-3 7h6L5 9zm14 0-3 7h6l-3-7z" />
            </svg>
          </button>

          <!-- Share Icon -->
          <button
            class="flex items-center justify-center w-10 h-10 bg-gray-100 hover:bg-blue-50 text-gray-600 hover:text-blue-600 rounded-full transition-all duration-200 hover:shadow-md"
            (click)="shareProduct()" [attr.aria-label]="'Udostępnij produkt' | translate"
            [title]="'Udostępnij produkt' | translate">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z">
              </path>
            </svg>
          </button>
        </div>

        <!-- View Details Button -->
        <button
          class="inline-flex items-center gap-2 px-3 py-2 md:px-4 md:py-2 bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-900 hover:to-black text-white rounded-lg font-medium text-sm transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 w-full sm:w-auto"
          [routerLink]="'/products/' + product?.id">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z">
            </path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
            </path>
          </svg>
          <span>{{ 'Zobacz szczegóły produktu' | translate }}</span>
        </button>
      </div>

    </div>

    <!-- Right Section - Product Information -->
    <div class="flex-1 min-w-0 min-h-0 flex flex-col">
      <!-- Scrollable Content Area -->
      <div class="product-info-scroll flex-1 min-h-0 overflow-y-auto p-3 md:p-4">
        <div class="space-y-3">
          <!-- Product Header -->
          <div class="border-b border-gray-100 pb-2">
            <div class="flex flex-wrap items-center gap-2 mb-2">
              <span
                class="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-black border border-orange-500 rounded-full uppercase tracking-wider">
                <svg class="w-3 h-3 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clip-rule="evenodd"></path>
                </svg>
                {{ 'Numer katalogowy:' | translate }} {{ product?.reference || 'brak' }}
              </span>
              <span *ngIf="product?.category"
                class="inline-flex items-center gap-1 px-2 py-1 border border-orange-500 text-black rounded-full text-xs font-semibold">
                <svg class="w-3 h-3 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z"
                    clip-rule="evenodd"></path>
                </svg>
                {{ product?.category?.label }}
              </span>
            </div>
            <h1 class="text-lg md:text-xl font-bold text-gray-600 leading-tight">{{ product?.label }}</h1>
            <h2 *ngIf="product?.secondLabel" class="text-sm md:text-base font-normal text-black">{{
              product?.secondLabel }}</h2>
          </div>

          <!-- Enhanced Pricing Section - Only show for valid products -->
          <div *ngIf="isValidProduct(product)" class="bg-white rounded-lg p-3 border border-gray-100 shadow-sm space-y-2">
            <app-product-pricing [discountRate]="product?.discountRate" [deliveryPrice]="deliveryPrice"
              [deliveryDays]="product?.deliveryDays" [priceHTTotal]="priceHTTotal"
              [priceWithTvaNoDiscount]="priceWithTvaNoDiscount" [finalPriceTTC]="finalPriceTTC"
              [tvaRate]="product?.tvaRate" [originalPriceTTC]="originalPriceTTC"
              [discountAmount]="discountAmount"></app-product-pricing>

            <!-- Shipping & Logistics Badges -->
            <div *ngIf="product?.weight || (product?.length && product?.width && product?.height) || product?.packageType || product?.isFreeShipping || product?.shippingClass === 'FREE_SHIPPING'"
              class="flex flex-wrap items-center gap-2 pt-1 border-t border-gray-100">
              <span *ngIf="product?.isFreeShipping || product?.shippingClass === 'FREE_SHIPPING'"
                class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
                <svg class="w-3 h-3 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                {{ 'Bezpłatna dostawa' | translate }}
              </span>
              <span *ngIf="product?.packageType"
                class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-700 border border-gray-200">
                {{ 'Opakowanie:' | translate }} {{ (product?.packageType === 'PALLET' ? 'Paleta' : product?.packageType === 'ENVELOPE' ? 'Koperta' : product?.packageType === 'BULK' ? 'Ładunek luzem' : 'Karton') | translate }}
              </span>
              <span *ngIf="product?.weight"
                class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-700 border border-gray-200">
                {{ 'Waga:' | translate }} {{ product?.weight }} {{ 'kg' | translate }}
              </span>
              <span *ngIf="product?.length && product?.width && product?.height"
                class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-700 border border-gray-200">
                {{ 'Wymiary:' | translate }} {{ product?.length }}{{ '×' | translate }}{{ product?.width }}{{ '×' | translate }}{{ product?.height }} {{ 'cm' | translate }}
              </span>
            </div>
          </div>

          <!-- Quote Request Section - Only show for products requiring quotes -->
          <div *ngIf="!isValidProduct(product)" class="rfq-card-enhanced space-y-2">
            <!-- Header (Icon + Title) -->
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-xl bg-orange-50 border border-orange-100 flex items-center justify-center flex-shrink-0 text-orange-500">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                </svg>
              </div>
              <h4 class="text-gray-950 font-bold text-base leading-snug">{{ 'Cena i dostępność na zapytanie' | translate }}</h4>
            </div>

            <!-- Description -->
            <p class="text-gray-600 text-sm leading-relaxed">
              {{ 'Zapytaj o aktualną cenę i szczegóły dostawy tego produktu.' | translate }}
            </p>
          </div>

          <!-- Enhanced Colors Selection -->
          <div class="space-y-2" *ngIf="product?.colors && product?.colors.length > 0">
            <div class="flex items-center gap-2">
              <h3 class="text-sm font-semibold text-gray-900">{{ 'Dostępne kolory' | translate }}</h3>
              <span class="text-xs text-gray-500">({{ product?.colors.length }})</span>
            </div>

            <div class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-3 lg:grid-cols-4 gap-2">
              <button *ngFor="let color of product?.colors; let i = index" (click)="onSelectColor(color)"
                class="group relative aspect-square overflow-hidden border-2 border-gray-200 rounded-md hover:border-orange-400 transition-all duration-200 hover:shadow-md">
                <img [src]="getFirstAvailableImageFromColor(color) || '/images/placeholder-product.svg'"
                  [alt]="color.colorName"
                  class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                  loading="lazy" />

                <!-- Color name overlay -->
                <div class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-1">
                  <p class="text-white text-xs font-medium truncate">{{ color.colorName }}</p>
                </div>
              </button>
            </div>
          </div>

          <!-- Loading Skeleton for Technical Data/Variants -->
          <div *ngIf="isLoadingFullDetails" class="bg-gray-50 rounded-lg p-3 space-y-3">
            <div class="h-4 bg-gray-200 rounded w-1/3"></div>
            <div class="border border-gray-200 rounded-lg overflow-hidden bg-white">
              <div class="divide-y divide-gray-200">
                <div *ngFor="let i of [1,2,3]" class="flex">
                  <div class="flex-1 px-4 py-3 border-r border-gray-200 bg-gray-50/50">
                    <div class="h-3 bg-gray-200 rounded w-2/3"></div>
                  </div>
                  <div class="flex-1 px-4 py-3">
                    <div class="h-3 bg-gray-100 rounded w-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product Variants -->
          <div class="bg-gray-50 rounded-lg p-3" *ngIf="!isLoadingFullDetails && variants && objectKeys(variants).length > 0">
            <app-product-variant (selectVariantEmitter)="onSelectVariant($event)" [variants]="variants"
              [variantKeys]="variantKeys" [selectedVariants]="selectedVariants"></app-product-variant>
          </div>


        </div>
      </div>

      <!-- Fixed Bottom Action Section -->
      <div class="flex-shrink-0 border-t border-gray-100 bg-white p-3 md:p-4">
        <!-- Show product actions for valid products -->
        <div *ngIf="isValidProduct(product)">
          <app-product-actions [quantity]="quantity" [saleUnit]="saleUnit" [product]="product"
            (quantityIncrement)="incrementQuantity()" (quantityDecrement)="decrementQuantity()"
            (addToCartClicked)="addToCart()" class="w-full"></app-product-actions>
        </div>

        <button *ngIf="!isValidProduct(product)" (click)="requestQuotation(product)"
          class="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-5 rounded-lg transition-colors flex items-center justify-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
            stroke="currentColor" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
          </svg>
          {{ 'Poproś o wycenę' | translate }}
        </button>

      </div>
    </div>
  </div>
</div>

<app-download-selection-modal
  [showModal]="showDownloadModal"
  [downloads]="product?.downloads || []"
  [productName]="product?.label || product?.title || ''"
  (closeEmitter)="closeDownloadModal()"
  (downloadSelectionConfirmed)="onDownloadSelectionConfirmed($event)">
</app-download-selection-modal>